import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type ReturnReasonState = readonly string[];

export const RETURN_REASON_STEP_TYPE_NAME = "Return reason";

export const RETURN_REASON = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ReturnReasonState>>,
): ConditionType<ReturnReasonState, Condition.ReturnReason> => ({
  name: RETURN_REASON_STEP_TYPE_NAME,
  description(state) {
    let baseDescription;
    if (state.length === 0) {
      baseDescription = "Return reasons: none selected";
    } else if (state.length === 1) {
      baseDescription = `Return reason: ${state[0]}`;
    } else {
      baseDescription = `Return reasons: ${state.length} selected`;
    }

    return `${baseDescription}. Doesn't apply to AI return reasons.`;
  },
  Details(props: ConditionTypeDetailsProps<ReturnReasonState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return model.reasons;
  },
  toModel(state) {
    return { type: Condition.RETURN_REASON, reasons: state };
  },
  valid(state) {
    return state.length > 0;
  },
});
